import { render } from "./UiPropValueSelector.vue?vue&type=template&id=116e146d"
import script from "./UiPropValueSelector.vue?vue&type=script&lang=js"
export * from "./UiPropValueSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__